import { deepClone } from '@nu-art/ts-common';
import { LikelihoodDirection_vD } from '../../_enum.js';
export const indicativeOptions = Object.freeze([
    { label: 'Rule In', value: 1 },
    { label: 'Rule Out', value: -1 },
]);
export const cleanDiseaseValue = Object.freeze({
    multiVarId: '',
    _diseaseProfileId: '',
    values: {},
    _values: [],
    _variables: [],
});
export const getCleanDiseaseValue = (diseaseProfileId, multiVarId) => {
    const dv = deepClone(cleanDiseaseValue);
    dv._diseaseProfileId = diseaseProfileId;
    dv.multiVarId = multiVarId;
    dv.likelihoodDirection = LikelihoodDirection_vD;
    return dv;
};
export const diseaseValueHasVariableValueConnection = (diseaseValue, variableId, valueId) => {
    return diseaseValue.values[variableId] === valueId;
};
//# sourceMappingURL=consts.js.map